import * as z from "zod";

export const ReviewSchema = z.object({
  acknowledgement: z.boolean().refine(val => val),
});
